import { useSourceLanguage } from "../i18n/LocalizedCopy";
import React from "react";
import { Link, useLocation } from "react-router-dom";

import useNavigationTranslations from "../i18n/useNavigationTranslations";
import { useAuth } from "../context/AuthContext";
import { formatWalletValue } from "./formatters";
import { useWalletSummary } from "./WalletContext";
import { WalletGlyph } from "./WalletComponents";

export default function WalletControl() {
  useSourceLanguage();
  const { user } = useAuth();
  const { translateLabel } = useNavigationTranslations();
  const location = useLocation();
  const {
    status,
    data,
    isRefreshing,
    amountsHidden,
    showHeaderBalance,
  } = useWalletSummary();
  const isActive = ["/portefeuille", "/mes-eternua/portefeuille"].includes(
    String(location.pathname || "").replace(/\/+$/, "") || "/"
  );
  const hasUsableData = Boolean(data) && ["ready", "stale", "offline"].includes(status);
  const balance = hasUsableData
    ? showHeaderBalance === false
      ? translateLabel("Masqué")
      : formatWalletValue({
        kind: "money",
        value: data.balanceMinor,
        currency: data.currency,
        hidden: amountsHidden,
        unavailableLabel: translateLabel("Indisponible"),
        })
    : null;
  const isLoading = Boolean(user) && !hasUsableData && ["idle", "loading"].includes(status);
  const destination = user ? "/portefeuille" : "/login?next=%2Fportefeuille";
  const accessibleState = !user
    ? "Connexion requise"
    : isLoading
      ? "solde en cours de chargement"
      : balance || "solde indisponible";

  return (
    <Link
      className={`et-wallet-control${isActive ? " is-active" : ""}${status === "offline" ? " is-offline" : ""}`}
      to={destination}
      aria-current={isActive ? "page" : undefined}
      aria-label={`${translateLabel(user ? "Ouvrir mon portefeuille" : "Accéder au portefeuille")}, ${translateLabel(accessibleState)}`}
      title={translateLabel(!user ? "Connecte-toi pour accéder à ton portefeuille" : "Ouvrir Mon portefeuille")}
    >
      <span className="et-wallet-control__icon"><WalletGlyph /></span>
      <span className="et-wallet-control__copy">
        <strong>{translateLabel("Portefeuille")}</strong>
        {!user ? (
          <small>{translateLabel("Se connecter")}</small>
        ) : isLoading ? (
          <span className="et-wallet-control__skeleton" aria-hidden="true" />
        ) : (
          <small>{balance || translateLabel("Indisponible")}</small>
        )}
      </span>
      {user && (status === "stale" || status === "offline") ? (
        <span
          className="et-wallet-control__state"
          aria-label={translateLabel(status === "offline" ? "Hors ligne" : "Données à actualiser")}
          title={translateLabel(status === "offline" ? "Hors ligne" : "Données à actualiser")}
        />
      ) : null}
      {user && isRefreshing && hasUsableData ? (
        <span className="et-wallet-control__refresh" aria-label={translateLabel("Actualisation en cours")} />
      ) : null}
    </Link>
  );
}
